import {Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BaseGridComponent} from 'app/core-ui/abstract/basegrid/basegrid.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {throwError} from 'rxjs';
import {MailService} from './list.service';

@Component({
  selector: 'list',
  templateUrl: 'list.component.html',
  providers: [MailService],
})
export class ListComponent extends BaseGridComponent<MailService> {
  public mailList: string[] = [];
  public title: string;
  public type: string;

  public categories = [
    {
      visual: 'inbox',
      icon: 'inbox',
      type: 'I',
    },
    /*
        {
            visual:'Sent',
            icon: 'paper-plane',
            type: 'S'
        },
        {
            visual:'Draft',
            icon: 'file',
            type: 'D'
        },
        */
    {
      visual: 'deleted',
      icon: 'trash',
      type: 'D',
    },
  ];

  public status: {isopen: boolean} = {isopen: false};
  public disabled: boolean = false;

  constructor(
    gridService: MailService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    public route: ActivatedRoute,
    logger: LogService,
    visualsService: VisualsService,
  ) {
    super(securityService, logger, visualsService, gridService, 'listComponent');

    this.group = 'listComponent';
    this.loadVisuals();

    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
      },
    });
  }

  ngOnInit() {
    this.type = 'I';
    this.setTitle(this.type);
    this.route.params.subscribe({
      next: (params) => {
        if (params['type'] != null) {
          this.setTitle(params['type']);
          this.type = params['type'];
        }
        this.search();
      },
    });
  }

  public getInitData(): void {
    if (this.continueWithSearch) {
      this.loading = true;
      this.searched = true;
      this.getDataCount();
    }
  }

  public getDataCount(): void {
    if (this.type == 'I') {
      this.gridService.getCount().subscribe({
        next: (data) => {
          this.count = data;
          if (this.count > 0) {
            this.calcPages();
            this.getHeaderData();
            this.getData();
            this.getFooterData();
          } else {
            this.loading = false;
          }
        },
        error: (error) => {
          this.loading = false;
          this.count = 0;
          return throwError(() => new Error(error));
        },
      });
    } else if (this.type == 'D') {
      this.gridService.getDeletedCount().subscribe({
        next: (data) => {
          this.count = data;
          if (this.count > 0) {
            this.calcPages();
            this.getHeaderData();
            this.getData();
            this.getFooterData();
          } else {
            this.loading = false;
          }
        },
        error: (error) => {
          this.loading = false;
          this.count = 0;
          return throwError(() => new Error(error));
        },
      });
    }
  }

  public getData(): void {
    let firstRow = 1 + this.pageSize * (this.pageNum - 1);
    let lastRow = firstRow + this.pageSize - 1;

    if (this.type == 'I') {
      this.gridService.getData({start: firstRow, end: lastRow}).subscribe({
        next: (data) => {
          this.grid = data;
          this.loading = false;
        },
        error: (error) => {
          this.loading = false;
          return throwError(() => new Error(error));
        },
      });
    } else if (this.type == 'D') {
      this.gridService.getDeleted({start: firstRow, end: lastRow}).subscribe({
        next: (data) => {
          this.grid = data;
          this.loading = false;
        },
        error: (error) => {
          this.loading = false;
          return throwError(() => new Error(error));
        },
      });
    }
  }

  public addToMailList(mailId: string) {
    var index = this.mailList.indexOf(mailId);
    if (index < 0) {
      this.mailList.push(mailId);
    } else {
      this.mailList.splice(index);
    }
    this.logger.log(this.mailList);
  }

  public isSelected(mailId: any): boolean {
    return this.mailList.some((id) => id == mailId);
  }

  public emptyMailList() {
    this.mailList = [];
  }

  public selectAll() {
    this.grid.forEach((element) => {
      this.addToMailList(element.mailId);
    });
  }

  public deselectAll() {
    this.emptyMailList();
  }

  public toggled(open: boolean): void {
    /*this.logger.log('Dropdown is now: ', open);*/
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  public readAction() {
    this.logger.log('marked as read');
  }

  public deleteAction() {
    if (!(this.mailList.length == 0)) {
      this.gridService.delete(this.mailList).subscribe({
        next: (data) => {
          this.search();
        },
        error: (error) => {},
      });
    } else {
      LogService.emitAlert({
        type: 'info',
        body: this.visuals.noMailSelected,
      });
    }
  }

  public restoreAction() {
    if (!(this.mailList.length == 0)) {
      this.gridService.restore(this.mailList).subscribe({
        next: (data) => {
          this.search();
        },
        error: (error) => {},
      });
    } else {
      LogService.emitAlert({
        type: 'info',
        body: this.visuals.noMailSelected,
      });
    }
  }

  public setTitle(type: string) {
    if (type == 'I') {
      this.logger.log(this.visuals);
      this.title = this.visuals['inbox'];
    } else if (type == 'D') {
      this.title = this.visuals['deleted'];
    }
  }

  handleChangePage(num: number, type: string) {
    super.changePage({num: num, type: type});
  }

  handleChangePageSize(num: number) {
    super.changePageSize(num);
  }
}
